<div id="{{position}}" class="position-relative">
  <div *ngIf="(loadingData$ | async)">
    <header [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
      class="app-header-background inline-gradient pb-20"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
      [ngClass]="activatePadding?'header-padding-top':''">
      <div class="app-header-section pt-20 global-max-width">
        <div fxLayout="row" fxLayout.sm="column" fxLayout.md="column" fxLayout.xs="column" fxLayoutAlign="start center">
          <div [attr.data-aos]="textAnimation ? textAnimation : null" fxFlex [fxFlexOrder]="1" fxFlex.gt-md="100%"
            fxFlex.lt-sm="100%" class="app-header-headline form-headline center">
            <h1 class="mat-h1 newsletter-title"
              [ngStyle]="{ 'color': titleColor?titleColor:textColor,'font-weight':fontWeight }" [ngClass]="[titleSize]"
              [innerHtml]="title | safeHtml"></h1>
            <h2 [ngStyle]="{ 'color': textColor }" [class]="textSize" [innerHtml]="text | safeHtml"></h2>
          </div>
          <div [attr.data-aos]="formAnimation ? formAnimation : null" fxFlex [fxFlexOrder]="2" fxFlex.gt-md="100%"
            fxFlex.lt-sm="100%" class="newsletter-form-nw">
            <div class="app-header-start">
              <form [formGroup]="newsletterFormGroup">
                <div *ngIf="errorMessage" class="error-message">{{errorMessage}}</div>
                <div>
                  <mat-form-field>
                    <input matInput placeholder="Email" formControlName="email">
                    <mat-label>Email </mat-label>
                  </mat-form-field>
                </div>
                <div>
                  <p class="small-legend">
                    <label for="consent-cta"
                      style="opacity: 0; position: absolute; right: -200000;">{{consentText}}</label>
                    <input type="checkbox" id="consent-cta" formControlName="consent">

                    <ng-container *ngIf="privacyPolicyExist">
                      <span style="cursor: pointer;vertical-align: top;" (click)="setConsentChecked()"
                        class="small-legend">
                        <a faria-labelledby="consent-cta" class="privacy-link" [href]="privacyPolicyLink"
                          target="_blank">{{consentText}}</a>
                      </span>
                    </ng-container>
                    <ng-container *ngIf="!privacyPolicyExist">
                      <span aria-labelledby="consent-cta" style="cursor: pointer;vertical-align: top;"
                        (click)="setConsentChecked()" class="small-legend">
                        {{consentText}}
                      </span>
                    </ng-container>
                  </p>
                </div>
                <div *ngIf="(loading$ | async) as loading">
                  <button *ngIf="loading == 'false' && !(successMsg$ | async)"
                    class="app-button mat-raised-button btn-large" mat-raised-button tabindex="0" aria-disabled="false"
                    color="primary" (click)="submitForm()" [disabled]="isFormInvalid()" [attr.aria-label]="buttonText">
                    {{ buttonText }}
                  </button>
                  <div class="text-center loading-form" *ngIf="loading == 'true' && !(successMsg$ | async)">
                    <mat-spinner color="accent" [diameter]="40"></mat-spinner>
                  </div>
                  <div *ngIf="(successMsg$ | async) as successMsg" class="success-msg">
                    {{successMsg}}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>